import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocale } from '../contexts/LocaleContext';
import { FormattedMembershipTerm, formatMembershipTerms } from '../lib/hardwareFirst';
import { getLocalizedPricing } from '../lib/util/money';
import * as types from '../types';

/** the membership terms `/products` publishes, priced and formatted for the active locale; empty until the config loads */
export default function useHardwareFirstMembershipTerms(): FormattedMembershipTerm[] {
  const terms = useSelector((state: types.AppState) => state.config.siteConfig.hardwareFirstMembershipTerms);
  const { currency, currencyFormatter, wholeNumberCurrencyFormatter } = useLocale();
  return useMemo(
    () =>
      formatMembershipTerms(
        terms,
        {
          priceInCents: (pricing) => getLocalizedPricing(pricing, currency),
          priceStepInCents: currency === types.FiCurrency.ISK ? 100 : 1,
        },
        { currencyFormatter, wholeNumberCurrencyFormatter },
      ),
    [terms, currency, currencyFormatter, wholeNumberCurrencyFormatter],
  );
}
